module.exports = __webpack_public_path__ + "static/media/group.0c0be62c.svg";